import React, { useState, useEffect } from 'react';
import SessionTypeIcon from './SessionTypeIcon';
import { bookings } from '../../api';

// ✅ FEATURE 18: Multi-select component for session type filtering
export default function SessionTypeSelector({ selectedTypes = [], onChange, showLabel = true }) {
  const [sessionTypes, setSessionTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSessionTypes();
  }, []);

  const loadSessionTypes = async () => {
    try {
      const response = await bookings.getSessionTypes();
      setSessionTypes(response.data.sessionTypes || []);
    } catch (error) {
      console.error('❌ Error loading session types:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (typeId) => {
    const newSelected = selectedTypes.includes(typeId)
      ? selectedTypes.filter(t => t !== typeId)
      : [...selectedTypes, typeId];
    onChange(newSelected);
  };

  if (loading) {
    return <div style={{ padding: '8px', color: '#999' }}>Loading session types...</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {showLabel && (
        <label style={{ fontSize: '13px', fontWeight: '600', color: '#2c3e50' }}>
          Filter by Session Type:
        </label>
      )}

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px'
      }}>
        {sessionTypes.map(type => (
          <button
            key={type.id}
            onClick={() => handleToggle(type.id)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 12px',
              borderRadius: '6px',
              border: selectedTypes.includes(type.id)
                ? `2px solid ${type.color}`
                : `1px solid #ddd`,
              background: selectedTypes.includes(type.id)
                ? `${type.color}15`
                : 'white',
              color: selectedTypes.includes(type.id)
                ? type.color
                : '#666',
              fontWeight: selectedTypes.includes(type.id) ? '600' : '500',
              cursor: 'pointer',
              fontSize: '12px',
              transition: 'all 0.2s',
              whiteSpace: 'nowrap',
              boxShadow: selectedTypes.includes(type.id)
                ? `0 0 0 2px ${type.color}20`
                : 'none'
            }}
            onMouseEnter={e => {
              if (!selectedTypes.includes(type.id)) {
                e.target.style.borderColor = type.color;
                e.target.style.background = `${type.color}08`;
              }
            }}
            onMouseLeave={e => {
              if (!selectedTypes.includes(type.id)) {
                e.target.style.borderColor = '#ddd';
                e.target.style.background = 'white';
              }
            }}
          >
            <span style={{ fontSize: '14px' }}>{type.emoji}</span>
            <span>{type.label}</span>
            {selectedTypes.includes(type.id) && (
              <span style={{ marginLeft: '4px', fontWeight: 'bold' }}>✓</span>
            )}
          </button>
        ))}
      </div>

      {selectedTypes.length > 0 && (
        <button
          onClick={() => onChange([])}
          style={{
            padding: '6px 12px',
            background: '#ecf0f1',
            color: '#7f8c8d',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px',
            alignSelf: 'flex-start',
            marginTop: '4px'
          }}
        >
          Clear All
        </button>
      )}
    </div>
  );
}
